module.exports = __webpack_public_path__ + "21b68d238cbac98c9eb4f5030de9e179.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/kampf_unclear.svg
// module id = 39
// module chunks = 0